export default {"src":"/_next/static/image/src/images/our-food/rosemary.2ee6a7aaa288c3b01c6af015f60e18af.svg","height":29,"width":84};